import Notice from '@/util/notice.base';

export default (
    message: string,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    callback: () => void = (): void => {},
    title: string = WordList.TabelDeleteTitle
) => {
    Notice.messageBox('confirm', message, title, 'warning')(callback);
};